
import AuthModule from '../store/auth.module'
import user from '../model/user'
import {defineComponent, ref } from 'vue'
import Profile from './usersettings/Profile.vue'
import Session from './usersettings/Session.vue'
import HistorySettings from './usersettings/HistorySettings.vue'
import LanguageSettings from './usersettings/LanguageSettings.vue'
import { useRoute } from 'vue-router';
import settingsItems from '../utils/adminsettingsitems'
import { useI18n } from 'vue-i18n';
import { useLogsPanel } from '@/composables/useLogsPanel'
import ServerInfo from './adminsettings/ServerInfo.vue'
import Activate from './adminsettings/Activate.vue'



export default defineComponent({
  components: { Profile,  LanguageSettings, ServerInfo, Activate},
  setup() {
    const route = useRoute()
    const {t} = useI18n({useScope:'global'})
     const { open } = useLogsPanel()
    let options = ref(settingsItems)
    const onTabChange = (name: string) => {
    if (name === 'logs') {
      open()
    }
  }
        return{
            tab: ref('profile'),
            tabsettings: ref('history'),
            splitterModel: ref(20),
            Profile,
            Session,
            HistorySettings,
            route,
            options,
            onTabChange,
            t
        }
    },
    computed: {
  currentUser():user {
      return AuthModule.currentUser;
    },
  },
  mounted():void {
    console.log(this.route.params.name)
    if (!this.currentUser) {
      this.$router.push('/login');
    }
  },
  methods: {
  
  }
})
